/* eslint-disable @typescript-eslint/no-explicit-any */
import { showDialog } from "@/component/Dialog";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import { useCallback } from "react";

const useCheckEditBeforeClick = <T extends (...args: any) => unknown>(fn: T) => {
  const recordEditing = summarySrcStore((state) => state.recordEditing);
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);

  const wrapFn = useCallback(
    async (...args: Parameters<T>) => {
      if (recordEditing || summaryEditing) {
        try {
          await showDialog({
            title: "当前还有未保存内容",
            content: "离开页面后将丢失编辑内容，确认离开吗？",
            confirmText: "确认",
            cancelText: "取消",
          });
          return fn(...args);
        } catch (error) {
          return;
        }
      }
      return fn(...args);
    },
    [fn]
  );

  return wrapFn;
};

export default useCheckEditBeforeClick;
